let store1 = {
  _axiosPromiseCancel: []
}

export default store1


// WEBPACK FOOTER //
// ./src/CancelToken.js